import Trans from "@/data/Trans.json";
export default {
  name: "StaticTrans",
  data() {
    return {
      TransData: Trans,
      snackbar: {
        prop: false,
        err: null,
        errColor: "red lighteen-2",
        succColor: "success",
      },
    };
  },
  computed: {
    trans: (app) => (page, name) => {
      return app.TransData[page][name];
    },
    status() {
      return [
        {
          value: false,
          text: this.trans("public", "inactive"),
        },
        {
          value: true,
          text: this.trans("public", "active"),
        },
      ];
    },
    blocks() {
      return [
        {
          value: true,
          text: this.trans("public", "block"),
        },
        {
          value: false,
          text: this.trans("public", "unblock"),
        },
      ];
    },

    default_locale() {

      if(this.$store.getters.default_lang) {
        return this.$store.getters.default_lang.locale;
      }

    },
    languages() {
      return this.$store.getters.items("langs").data;
    },
  },
};
